import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { Link } from 'roo-ui/components';

const Indicator = styled.sup`
  ::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 400%;
    transform: translate(-50%, 0);
    margin-left: 50%;
  }
`;

const BaseDisclaimerLink = ({ indicator, elementId }) => (
  <Link href={`#${elementId}`} aria-labelledby={elementId} color="inherit">
    <Indicator>{indicator}</Indicator>
  </Link>
);

BaseDisclaimerLink.propTypes = {
  indicator: PropTypes.string.isRequired,
  elementId: PropTypes.string.isRequired,
};

export default BaseDisclaimerLink;
